import {createRule, type Maybe} from '@regle/core';
import {minValue} from '@regle/rules';
import {useTranslation} from '#imports';

/**
 * Requires a field to have a specified minimum year value.
 *
 * @param minYear - the minimum year
 *
 * @example
 * ```ts
 *  import { useRegle, minYear } from '@malt/forms';
 *
 *  const { r$ } = useRegle(... , {
 *    graduationYear: { minYear: minYear(1900) }
 *  })
 * ```
 */
export const minYear = createRule({
    type: 'minValue',
    validator: (value: Maybe<number>, minYear: number, options?: {allowEqual: boolean}) => {
        return minValue(minYear, options).exec(value);
    },
    message: ({$params: [minYear, options]}) => {
        const {t} = useTranslation();

        return (options?.allowEqual ?? true)
            ? t('generic.forms.validation.errors.minYear.equal', [String(minYear)])
            : t('generic.forms.validation.errors.minYear', [String(minYear)]);
    },
});
